import { render, staticRenderFns } from "./DeliveriesMassiveChangeDriver.vue?vue&type=template&id=b78396e2&scoped=true&lang=pug&"
import script from "./DeliveriesMassiveChangeDriver.vue?vue&type=script&lang=js&"
export * from "./DeliveriesMassiveChangeDriver.vue?vue&type=script&lang=js&"
import style0 from "./DeliveriesMassiveChangeDriver.vue?vue&type=style&index=0&id=b78396e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78396e2",
  null
  
)

export default component.exports